import React from 'react';

import './smartImage.scss';

export default class SmartImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // change to true
      lowResHidden: true,
      highResHidden: true,
      highResLoaded: false
    };
  }

  setClassNamesImage() {
    if (this.props.campaignType === 'general') {
      return this.props.className;
    }
    if (
      this.props.campaignType !== 'general' &&
      this.props.className !== undefined
    ) {
      return `progressive-image-loading ${this.props.className}`;
    }
    return 'progressive-image-loading';
  }

  handleImageLoad(event, done) {
    // Tell the app that the engage has been loaded, to enable rendering of other sections
    if (this.props.loaded && done) this.props.loaded();
    this.setState({ [event.target.name]: false });
    if (
      this.props.campaignType === 'general' &&
      event.target.name === 'highResHidden'
    ) {
      this.setState(prevState => {
        return {
          ...prevState,
          highResLoaded: true
        };
      });
    }
  }

  render() {
    return (
      <div className={this.setClassNamesImage()}>
        {!this.state.highResLoaded && (
          <picture>
            <source
              media="(min-width: 768px)"
              srcSet={`${this.props.slug}load/desktop/${this.props.name}?version=${this.props.version}`}
            />
            <source
              srcSet={`${this.props.slug}load/mobile/${
                this.props.mobilename !== undefined
                  ? this.props.mobilename
                  : this.props.name
              }?version=${this.props.version}`}
            />
            <img
              alt={`${
                this.props.alt !== undefined
                  ? this.props.alt
                  : window.campaign_data.campaign_translations.title
              }`}
              className={
                this.state.lowResHidden && !this.state.highResHidden
                  ? 'img-low-res hide'
                  : 'img-low-res show'
              }
              name="lowResHidden"
              src={`${this.props.slug}load/mobile/${
                this.props.mobilename !== undefined
                  ? this.props.mobilename
                  : this.props.name
              }?version=${this.props.version}`}
              onLoad={event => this.handleImageLoad(event, false)}
            />
          </picture>
        )}
        {this.state.lowResHidden ? (
          <span />
        ) : (
          <picture>
            <source
              media="(min-width: 1680px)"
              srcSet={`${this.props.slug}2160/${this.props.name}?version=${this.props.version}`}
            />
            <source
              media="(min-width: 768px)"
              srcSet={`${this.props.slug}1680/${this.props.name}?version=${this.props.version}`}
            />
            <source
              srcSet={`${this.props.slug}mobile/${
                this.props.mobilename !== undefined
                  ? this.props.mobilename
                  : this.props.name
              }?version=${this.props.version}`}
            />
            <img
              alt={`${
                this.props.alt !== undefined
                  ? this.props.alt
                  : window.campaign_data.campaign_translations.title
              }`}
              className={
                this.state.highResHidden
                  ? 'img-high-res hide'
                  : 'img-high-res show'
              }
              name="highResHidden"
              src={`${this.props.slug}mobile/${
                this.props.mobilename !== undefined
                  ? this.props.mobilename
                  : this.props.name
              }?version=${this.props.version}`}
              onLoad={event => this.handleImageLoad(event, true)}
            />
          </picture>
        )}
      </div>
    );
  }
}
